import { render, staticRenderFns } from "./CaixaFechado.vue?vue&type=template&id=08cac47c&"
import script from "./CaixaFechado.vue?vue&type=script&lang=js&"
export * from "./CaixaFechado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports